// extracted by mini-css-extract-plugin
export var checkbox = "GdprSettings-module--checkbox--90vHW";
export var smallButton = "GdprSettings-module--smallButton--2_r_g";
export var spinAround = "GdprSettings-module--spinAround--opKhO";